import React from 'react';
import { IconCheckBoxIndeterminateOutlined, IconCheckBoxOutlined } from '../../../icons/iconsMaterial';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * MuiCheckbox
 *
 *
 * API:
 *
 * - inherits [MuiButton API](https://mui.com/material-ui/api/button/)
 *
 * Styles:
 *
 * - [Proto](https://bhdgwebdesignsa.z22.web.core.windows.net/atoms.html#form-fields-controls--checkbox)
 */

const MuiCheckbox = {
  defaultProps: {
    checkedIcon: /*#__PURE__*/_jsx(IconCheckBoxOutlined, {}),
    indeterminateIcon: /*#__PURE__*/_jsx(IconCheckBoxIndeterminateOutlined, {}),
    color: 'secondary',
    disableRipple: true
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '&:hover': {
        color: theme.palette.secondary.main
      },
      '&:focus-within': {
        color: theme.palette.secondary.light,
        '& .MuiSvgIcon-root': {
          outline: `2px solid ${theme.palette.secondary.light}`,
          borderRadius: '4px'
        }
      }
    })
  }
};
export default MuiCheckbox;